export function zeroPad(value: number) {
  return value < 10 ? `0${value.toFixed(0)}` : value.toFixed(0);
}
